<div class="chemical-exposure">
  @if (showIdentityFields) {
    <h3 class="chemical-exposure__title">{{ 'chemicalExposure' | translate }}</h3>
  }
  <app-shared-ui-datepicker
    *appUseDateTimeFormat
    [label]="'dateTime' | translate"
    [control]="form.exposedAt"
    [required]="true"
  ></app-shared-ui-datepicker>
  @if (showIdentityFields) {
    <app-ui-input
      class="disabled"
      [label]="'substanceName' | translate"
      [control]="form.substanceName"
      [required]="true"
      [tabIndex]="-1"
    ></app-ui-input>
    <app-ui-input
      class="disabled"
      [label]="'manufacturerName' | translate"
      [control]="form.manufacturerName"
      [tabIndex]="-1"
    ></app-ui-input>
  }
  <app-ui-select
    [label]="'exposureDuration' | translate"
    [control]="form.exposureDurationId"
    [options]="exposureDurations"
    [required]="true"
    [isMultiple]="false"
    [disabled]="isLocked"
  ></app-ui-select>
  <app-shared-ui-radio
    [label]="'placement' | translate"
    [control]="form.exposurePlacement"
    [options]="placementOptions"
    [required]="true"
  ></app-shared-ui-radio>
  <app-ui-input
    [label]="'exposureLocation' | translate"
    [control]="form.exposureLocation"
    [required]="true"
  ></app-ui-input>
  <app-shared-ui-checkbox
    [label]="'safetyDataSheetRead'"
    [control]="form.safetyDataSheetConfirmed"
    [required]="true"
  ></app-shared-ui-checkbox>
  <h3 class="chemical-exposure__title">
    {{ 'tagParticipants' | translate }}
    <span class="required-marker" aria-hidden="true">*</span>
  </h3>
  <div class="slide-toggle-labels">
    <span>{{ 'allUsers' | translate }}</span>
    <app-ui-slide-toggle
      label="{{ 'currentPersonnel' | translate }}"
      [control]="showOnBoard"
      (changeHandler)="onShowOnBoardChange($event)"
    ></app-ui-slide-toggle>
  </div>
  <app-ui-table-selection
    [control]="form.exposedUserIds"
    [displayedColumns]="participantColumns"
    [dataSource]="showOnBoard.value ? (currentPersonnel$ | async) : (participants$ | async)"
    [toggleAllEnabled]="true"
    [disabled]="isLocked"
  ></app-ui-table-selection>
</div>
